import { ISODateString } from 'models/misc'

/** Anything carrying a shooting start, e.g. an assignment of any role's DTO */
interface WithShootingStart {
  shootingStartDateTime: ISODateString | null
}

/**
 * Comparator ordering by shooting start ascending, undated items (no shooting start, e.g. non-CT
 * assignments) last. Never yields NaN, so the sort result does not depend on the input order.
 */
export const compareByShootingStart = (a: WithShootingStart, b: WithShootingStart): number => {
  if (!a.shootingStartDateTime && !b.shootingStartDateTime) return 0
  if (!a.shootingStartDateTime) return 1
  if (!b.shootingStartDateTime) return -1
  return new Date(a.shootingStartDateTime).getTime() - new Date(b.shootingStartDateTime).getTime()
}

/**
 * The item with the earliest shooting start, ignoring undated items; null when none is dated.
 * Does not mutate the input, which is usually a React Query cache array.
 */
export const earliestByShootingStart = <T extends WithShootingStart>(items: readonly T[] | null | undefined): T | null => {
  const earliest = items?.length ? [...items].sort(compareByShootingStart)[0] : undefined
  return earliest?.shootingStartDateTime ? earliest : null
}
